// extracted by mini-css-extract-plugin
export var clickableWrapper = "_2l-2";
export var placeholderIcon = "_2l-3";
export var thumbnailCanvas = "_2l-1";
export var thumbnailWrapper = "_2l-0";